module.exports = __webpack_public_path__ + "media/images/category/feature/coj_c/hero-a9b360ef0f1caeae0dad98fa02b1f392.jpg";